import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { useMemo } from 'react';

const cities = [
  { name: 'Bordeaux', path: '/bordeaux', icon: 'ri-building-line' },
  { name: 'Mérignac', path: '/merignac', icon: 'ri-community-line' },
  { name: 'Pessac', path: '/pessac', icon: 'ri-home-4-line' },
  { name: 'Talence', path: '/talence', icon: 'ri-home-smile-line' },
  { name: 'Bègles', path: '/begles', icon: 'ri-home-3-line' },
  { name: 'Villenave-d\'Ornon', path: '/villenave-ornon', icon: 'ri-home-2-line' },
  { name: 'Cenon', path: '/cenon', icon: 'ri-home-5-line' },
  { name: 'Floirac', path: '/floirac', icon: 'ri-home-6-line' },
  { name: 'Gradignan', path: '/gradignan', icon: 'ri-home-7-line' },
  { name: 'Le Bouscat', path: '/le-bouscat', icon: 'ri-home-8-line' },
  { name: 'Bruges', path: '/bruges', icon: 'ri-building-2-line' },
  { name: 'Eysines', path: '/eysines', icon: 'ri-building-3-line' },
  { name: 'Blanquefort', path: '/blanquefort', icon: 'ri-building-4-line' },
  { name: 'Le Haillan', path: '/le-haillan', icon: 'ri-home-heart-line' },
  { name: 'Saint-Médard-en-Jalles', path: '/saint-medard-jalles', icon: 'ri-home-wifi-line' },
  { name: 'Lormont', path: '/lormont', icon: 'ri-home-gear-line' },
  { name: 'Cestas', path: '/cestas', icon: 'ri-ancient-gate-line' },
  { name: 'Arcachon', path: '/arcachon', icon: 'ri-ship-line' },
  { name: 'La Teste-de-Buch', path: '/la-teste-buch', icon: 'ri-sailboat-line' },
  { name: 'Gujan-Mestras', path: '/gujan-mestras', icon: 'ri-anchor-line' },
  { name: 'Biganos', path: '/biganos', icon: 'ri-water-flash-line' },
  { name: 'Libourne', path: '/libourne', icon: 'ri-goblet-line' },
  { name: 'Carbon-Blanc', path: '/carbon-blanc', icon: 'ri-plant-line' },
  { name: 'Artigues-près-Bordeaux', path: '/artigues-bordeaux', icon: 'ri-leaf-line' }
];

export function ServiceAreas() {
  const citiesList = useMemo(() => cities, []);

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <div className="inline-block bg-teal/10 text-teal px-6 py-2 rounded-full text-sm font-semibold mb-6">
            ZONES D'INTERVENTION
          </div>
          <h2 className="text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
            Nous Intervenons<br />
            Partout en Gironde
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Service de réparation de fenêtres disponible dans toute la métropole bordelaise et le bassin d'Arcachon
          </p>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {citiesList.map((city, index) => (
            <Link
              key={index}
              to={city.path}
            >
              <motion.div
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: index * 0.03 }}
                whileHover={{ y: -5, boxShadow: '0 10px 30px rgba(0,0,0,0.15)' }}
                className="bg-gradient-to-br from-white to-teal/5 border-2 border-teal/20 rounded-2xl p-6 hover:border-teal transition-all duration-300 cursor-pointer"
              >
                <div className="w-12 h-12 flex items-center justify-center mb-4">
                  <i className={`${city.icon} text-4xl text-teal`}></i>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">
                  {city.name}
                </h3>
                <div className="flex items-center gap-2 text-sm text-teal font-semibold">
                  <span>Voir les services</span>
                  <i className="ri-arrow-right-line"></i>
                </div>
              </motion.div>
            </Link>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.3 }}
          className="mt-16 text-center"
        >
          <p className="text-lg text-gray-600 mb-8">
            Votre ville n'est pas dans la liste ? Contactez-nous pour vérifier notre disponibilité
          </p>
          <Link to="/bordeaux">
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="px-10 py-5 bg-teal hover:bg-teal-dark text-white rounded-full font-semibold text-lg shadow-xl hover:shadow-2xl transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Demander un Devis Gratuit
            </motion.button>
          </Link>
        </motion.div>
      </div>
    </section>
  );
}